// extracted by mini-css-extract-plugin
export default {"singlePanelMode":"48em","booker":"booker__b9uM2","errorMessage":"errorMessage__1Bpbr"};
    if(module.hot) {
      // 1788784382976
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  